"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = require("./colors");
const icons_1 = require("./icons");
const l10n_1 = require("./l10n");
const sizes_1 = require("./sizes");
const typography_1 = require("./typography");
/**
 * Main entry class for getting all whitelabel information from a central place
 */
class Whitelabel {
    /**
     * Needs to be called once per application to setup the branding, further access should be done using the getInstance method
     * @param branding
     */
    static init(branding) {
        Whitelabel.instance = new Whitelabel(branding);
    }
    /**
     * Get the single instance for whitelabeling access
     * @returns
     */
    static getInstance() {
        return Whitelabel.instance;
    }
    /**
     * Main constructor for initializing the branding information
     * @param branding
     */
    constructor(branding) {
        this.COLORS = (0, colors_1.getColors)(branding);
        this.TYPOGRAPHY = (0, typography_1.getTypography)(branding);
        this.ICONS = (0, icons_1.getIcons)(branding);
        this.SIZES = (0, sizes_1.getSizes)(branding);
        this.LOCALIZATIONS = (0, l10n_1.getL10n)(branding);
    }
}
exports.default = Whitelabel;
//# sourceMappingURL=whitelabel.js.map